import { render, staticRenderFns } from "./uploadFile.vue?vue&type=template&id=d19a99de&scoped=true&"
import script from "./uploadFile.vue?vue&type=script&lang=js&"
export * from "./uploadFile.vue?vue&type=script&lang=js&"
import style0 from "./uploadFile.vue?vue&type=style&index=0&id=d19a99de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19a99de",
  null
  
)

export default component.exports